import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import '../../../assets/fonts/fontawesome/css/all.min.css';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';
import swal from 'sweetalert';


const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');

class UnitsNearExpiration extends Component{
	constructor(props){
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.setTable = this.setTable.bind(this);

		this.state = {
			submenu: "",
			results: [],
			blood_components:[],
			component:"all",
			status:"all",
			status_list:[],

			columns:[
				{title:'Num. Unidad'},
				{title:'Num. Componente'},
				{title:'Componente'},
				{title:'Cod. Componente'},
				{title:'Grupo & RH'},
				{title:'Volumen'},
				{title:'Fecha Caducidad'},
				{title:'Estatus'},
				
			],
			filename:"Unidades Proximas a Caducar",
			date_hour:"",
			expiration_hour:"",
		}
	}

	componentDidMount(){
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=NUM_HRS_ALERT_CAD_UNIT&x=', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					expiration_hour: response.value
				});
			}
		});

		var submenu = this.state.submenu === "" ? this.props.match.path.replace('/', '') : this.state.submenu;
		this.setState({
			submenu: submenu
		});

		/*fetch(Config.default.apiGateway.URL+'list_show/by_key?key=UNITS',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => response.json())
      	.then(response => {
        	if(response !== undefined){
        		var columns = [];
          		response.map((res)=>{
					if(res.active){
						var index = this.state.columns.findIndex(obj => 
							obj.title.toUpperCase() === res.column_name
						);

						if(index !== -1)
							columns[index] = {
								title: index !== -1 ? res.column_name : '',
								visible: true
							};
						else{
							columns.push({
								title: index !== -1 ? res.column_name : '',
								visible: true
							});
						}

							
					}else{
						var index = this.state.columns.findIndex(obj => 
							obj.title.toUpperCase() === res.column_name
						);

						if(index !== -1)
							columns[index] = {
								title: index !== -1 ? res.column_name : '',
								visible: false
							};
						else{
							columns.push({
								title: index !== -1 ? res.column_name : '',
								visible: false
							});
						}
					}
				});

				this.setState({
					columns: columns
				});
        	}
      	});*/

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		});

		this.setTable();

		setTimeout(()=>{
			this.searching();
		},1000);
		
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	searching(){
		this.props.waiting.handleShow("Cargando...");
		fetch(Config.default.apiGateway.URL+'units/get_prox_cad?hf_id='+
			sessionStorage.getItem("health_facilities_id")+'&to_show='+this.state.expiration_hour, {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Conten-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}

		})
		.then(response=>{
			this.props.waiting.handleClose();
			if(response !== undefined){
				var list = [];

				response.map((res)=>{
					var obj = [];

					obj.push(
						res.unit_number,
						res.component_number,
						res.component,
						res.code,
						res.group + (res.rh==="POSITIVO"?"+":res.rh==="NEGATIVO"?"-":'-'),
						res.volume,
						moment(res.caducidad).format("DD/MM/YYYY HH:mm"),
						res.status
					)

					list.push(obj);
				})

				setTimeout(()=>{
					this.props.waiting.handleShow('Cargando...');
					this.$el = $(this.el);
					this.$el.DataTable().destroy();
					this.$el.empty();
				}, 500);

				setTimeout(()=>{
					this.props.waiting.handleClose();
					this.setTable();
				}, 1000);

				this.setState({
					results: list
				})
			}
				
		})
	}

	setTable(){
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: 'Fecha de emisión '+this.state.date_hour, margin:[10,0,0,10] });
						doc.content[3].table.body.map((b, i)=>{
                			b.map((t, j)=>{
                				if(j>=0 && j<2 || j>2 && j<7){
            						b[j].alignment = 'center' 
                				}
                			})
                		})
						doc.content[3].table.widths=["5%","8%","30%","10%","10%","10%","10%", "17%"];
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                	} 
            	},
            ],
			data: this.state.results,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando..."
			},
			paging:false,
			responsive:true,
			searching: true,
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			createdRow: (row, data, dataIndex)=>{
				/*var btn = 0;
				this.state.columns.map((c)=>{
					if(!c.visible){
						btn++;
					}
				})

				//$('td:eq(0)', row).attr('class', 'td-number');
				$('td:eq(5)', row).attr('class', 'td-number');

				if(data[data.length - 2] === 'RESERVADA' || data[data.length - 2] === 'PENDIENTE DE VALIDAR'){
					$('td:eq('+(data.length - (btn+1))+')', row).html(
	                	'<button class="btn btn-info info_unit" id='+data[data.length - 1]+'>'+
	                		'<i class="fa fa-search" aria-hidden="true"></i>'+
	                	'</button>'
	                )
				}else{
	               $('td:eq('+(data.length - (btn+1))+')', row).html('')
            	}*/
			}
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

		
		$('.dataTables_filter').css('float', 'left');
		$('.dataTables_wrapper .dt-buttons').css('float', 'right')

	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	

	render(){

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						Inicio -> 
						Almacén
					</h5>
				</div>

				<div className="col-xs-12 col-sm-2 form-group component">
					<span className="span-min">Horas Expiración</span>
					<input type="number" className="form-control hour-input" name="expiration_hour" id="expiration_hour" 
						value={this.state.expiration_hour} onChange={this.handleChange} />						
				</div>

				<div className="col-xs-12 col-sm-1 form-group search">
					<button type="button" className="btn btn-info" style={{marginTop:"10px", fontSize:"1em"}}
						onClick={this.searching}>
						Buscar
					</button>
				</div>

				<div className="col-xs-12 form-group" id="table-to-pdf" style={{marginBottom:"8em"}}>
					<div className="table-responsive">
						<table style={{fontSize:"11px"}} className={"table"} id="table-to-xls" width="100%" ref={el => this.el = el}>
						</table>
					</div>
				</div>
				
			</div>
		)
	}
}

export default translate('translations')(UnitsNearExpiration)